var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShiftNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Shift_Notes"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shift_Notes",
    "data-name": "Shift Notes",
    clipPath: "url(#clip-Shift_Notes)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notes",
    transform: "translate(8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M9.917,22.917A4.168,4.168,0,0,1,5.75,18.75V4.167a4.167,4.167,0,1,1,8.333,0V18.75A4.168,4.168,0,0,1,9.917,22.917Z",
    transform: "translate(11.875)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_402",
    "data-name": "Path 402",
    d: "M14.667,22.917A4.168,4.168,0,0,1,10.5,18.75V4.167a4.167,4.167,0,1,1,8.333,0V18.75A4.168,4.168,0,0,1,14.667,22.917Z",
    transform: "translate(26.917)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_403",
    "data-name": "Path 403",
    d: "M19.417,22.917A4.168,4.168,0,0,1,15.25,18.75V4.167a4.167,4.167,0,0,1,8.333,0V18.75A4.168,4.168,0,0,1,19.417,22.917Z",
    transform: "translate(41.958)",
    fill: "#e8eaf0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_404",
    "data-name": "Path 404",
    d: "M69.708,2.25H13.458A11.468,11.468,0,0,0,2,13.708V81.417A11.468,11.468,0,0,0,13.458,92.875h56.25A11.468,11.468,0,0,0,81.167,81.417V13.708A11.468,11.468,0,0,0,69.708,2.25ZM22.833,26.208H43.667a4.167,4.167,0,0,1,0,8.333H22.833a4.167,4.167,0,1,1,0-8.333ZM64.5,67.875H22.833a4.167,4.167,0,0,1,0-8.333H64.5a4.167,4.167,0,1,1,0,8.333Zm0-16.667H22.833a4.167,4.167,0,1,1,0-8.333H64.5a4.167,4.167,0,1,1,0,8.333Z",
    transform: "translate(0 7.125)",
    fill: "#e8eaf0"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShiftNotes);
export default __webpack_public_path__ + "static/media/shift-notes.d30b3cd24f5897a22e05e9938bbb6d47.svg";
export { ForwardRef as ReactComponent };